import aspectRatio from "components/utils/aspectRatio";
import type { SVGProps } from "react";

const CVMSquaredIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {...aspectRatio({
      originalWidth: 25.2,
      originalHeight: 32.041,
      desiredHeight: 18,
    })}
    {...props}
    viewBox="0 0 25.2 32.041"
  >
    <g fillRule="nonzero" fill="none">
      <path
        d="M0 12.441c0-.1 0-.1.1-.2l.2-.2L12.1.241c.1-.1.2-.1.2-.2.4.1.3.5.3.7v5.3c0 .3-.2.5-.4.7-1.8 1.7-3.5 3.5-5.3 5.2-.5.5-.5.5 0 1l5.2 5.2c.4.4.4.4.9 0l5.3-5.3c.2-.2.4-.4.7-.5 1.8-.1 3.7 0 5.5 0 .1 0 .3 0 .4.1.2.1.2.3 0 .5-.1.2-.2.3-.4.4-3.8 3.6-7.6 7.4-11.4 11.2-.6.6-.6.6-1.2 0L.5 13.141c-.2-.2-.4-.4-.5-.7Z"
        fill="#4B8C6A"
      />
      <path
        d="M25.1 18.741c.1.2.1.4.1.6V31.841c0 .1-.1.2-.2.2H.6c-.5 0-.5 0-.5-.5v-12.7c.3 0 .5.2.6.4 3.9 3.8 7.7 7.7 11.5 11.5.1.1.2.3.4.3l11.9-11.9c.1-.1.2-.4.6-.4Z"
        fill="#187452"
      />
      <path
        d="m25.1 18.741-.5.5c-3.9 3.9-7.7 7.8-11.6 11.6l-.4.4c-.2-.1-.3-.3-.5-.4-3.9-3.9-7.8-7.8-11.6-11.7l-.4-.4v-6.3l.4.4 11.6 11.6.4.4c.2 0 .2-.1.3-.2l12-12 .2-.2c0-.1.1-.1.1 0v6.3Z"
        fill="#FBC71A"
      />
      <path
        d="M25.1 12.441H25c-.1-.1-.1-.1-.2-.1h-6c-.2 0-.3-.2-.4-.3l-5.4-5.4c-.1-.1-.3-.2-.3-.4-.1-.2-.1-.4-.1-.6V.341c0-.1 0-.2-.1-.2.1-.1.2-.2.3-.1l.3.3 11.8 11.8c-.1 0 .1.1.2.3Z"
        fill="#8FB195"
      />
      <path
        d="m12.6 6.141.3.3 5.6 5.6.3.3c-.1.1-.1.2-.2.3l-5.8 5.8-.2.2c-.2-.1-.3-.2-.4-.3l-5.5-5.5-.2-.2c-.2-.2-.2-.2 0-.4.6-.7 1.3-1.3 2-2 .5-.5 1-1.1 1.6-1.6.8-.8 1.6-1.5 2.4-2.3 0-.1 0-.1.1-.2Z"
        fill="#187452"
      />
    </g>
  </svg>
);

export default CVMSquaredIcon;
